import React from 'react';
import styled from '@emotion/styled';
import { Link } from '@reach/router';
import { COLORS, EXEMPLAR_FOCUS } from '../../constants';

interface ILink {
  color: string;
  hoverFontColor: string;
  BGColor: string;
  hoverColor: string;
  hasTooltip?: boolean;
}

export const StyledTextType = styled(({ BGColor, hoverColor, hoverFontColor, color, hasTooltip, ...rest }) => (
  <Link {...rest} />
))<ILink>`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  border: 1px solid #dfdfdf;
  box-shadow: 0 0 0 1px #f1f1f1;
  background: ${({ BGColor }) => (BGColor ? BGColor : COLORS.white)};
  padding: ${({ hasTooltip }) => (hasTooltip ? '0 px' : '15px 0 15px 0')};
  cursor: pointer;
  text-decoration: none;
  font-size: 16px;
  color: ${({ color }) => color};

  ${EXEMPLAR_FOCUS};

  :hover,
  :focus {
    color: ${({ hoverFontColor }) => hoverFontColor};
    background: ${({ hoverColor }) => (hoverColor ? hoverColor : COLORS.hover)};
  }
`;

export const StyledEngagementPromptsButton = styled.button<{
  BGColor: string;
  hoverColor: string;
  hoverFontColor: string;
  color: string;
  isFullWidth: boolean;
}>`
  height: 54px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding-left: 42px;
  border: 1px solid #dfdfdf;
  box-shadow: 0 0 0 1px #f1f1f1;
  cursor: pointer;
  text-decoration: none;
  text-transform: uppercase;
  font-size: 16px;
  font-weight: 600;
  color: ${({ color }) => color};
  background: ${({ BGColor }) => (BGColor ? BGColor : COLORS.white)};

  ${({ isFullWidth }) =>
    isFullWidth &&
    `
     grid-column-start: 1;
     grid-column-end: 4;
  `}
  ${EXEMPLAR_FOCUS};

  :hover,
  :focus {
    color: ${({ hoverFontColor }) => hoverFontColor};
    background: ${({ hoverColor }) => (hoverColor ? hoverColor : COLORS.hover)};
  }

  :disabled {
    cursor: not-allowed;
  }

  svg {
    margin-left: 14px;
  }
`;

export const StyledTextTypeLabel = styled.span`
  text-transform: uppercase;
`;
